module.exports = __webpack_public_path__ + "img/klogooficial.2c0bedb6.png";